import { Modal, Field, Text } from "components/commons";
import locale from "localization";
import React from "react";
import styles from "./pay-with-locqpay-receipt-guide-modal.module.scss";
import moment from "moment";
import { DateTime } from "enums";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { formatAmount } from "utils/text.utils";
import { prettifyProduct } from "utils/pretty.utils";
import Big from "big.js";

const PayWithLOCQPayReceiptGuideModal = ({
  close,
  active,
  loading,
  title,
  description,
  redemptionItem,
  label,
}) => {
  const vatDivide = 1.12;
  const volume = redemptionItem?.literVolume || 0;
  const unitPrice = Number(redemptionItem?.pumpPrice || 0);
  const unitAmount = Number(redemptionItem?.amount || 0);
  const discountPerUnit = Number(Big(redemptionItem?.discount || 0));
  const discountPerTotal = Number(Big(redemptionItem?.totalDiscount || 0));
  const totalAmountDue = Number(Big(unitAmount)) - discountPerTotal;
  const vatableSales = totalAmountDue / vatDivide;
  const vatAmount = totalAmountDue - vatableSales;
  return (
    <Modal active={active} title={title} close={close} className={styles.modal}>
      <div className={styles.headerReceiptGuide}>
        <div className={styles.headerLeftPart}>
          <Field
            className={styles.fieldLabelGuide}
            labelClassName={styles.fieldLabelInfo}
            label={locale.businessName}
            labelPosition="left"
            childrenClassName={styles.fieldContent}
          >
            <Text strong>{redemptionItem?.fleet?.businessName}</Text>
          </Field>

          <Field
            className={styles.fieldLabelGuide}
            labelClassName={styles.fieldLabelInfo}
            label={locale.fleetCardNo}
            labelPosition="left"
            childrenClassName={styles.fieldContent}
          >
            <Text strong>{redemptionItem?.cardNumber}</Text>
          </Field>
        </div>

        <div className={styles.headerRightPart}>
          <Field
            className={styles.fieldLabelGuide}
            labelClassName={styles.fieldLabelInfo}
            label={locale.locqPayId}
            labelPosition="left"
            childrenClassName={styles.fieldContent}
          >
            <Text strong>{redemptionItem?.paymentId}</Text>
          </Field>

          <Field
            className={styles.fieldLabelGuide}
            labelClassName={styles.fieldLabelInfo}
            label={locale.dateTime}
            labelPosition="left"
            childrenClassName={styles.fieldContent}
          >
            <Text strong>
              {moment(redemptionItem?.paidAt).format(DateTime.A)}{" "}
              {moment(redemptionItem?.paidAt).format(DateTime.B)}
            </Text>
          </Field>
        </div>
      </div>
      <TableContainer component={Paper} className={styles.tableReceiptGuide}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead className={styles.tableHead}>
            <TableRow>
              <TableCell>Volume</TableCell>
              <TableCell>Unit</TableCell>
              <TableCell>Product Description</TableCell>
              <TableCell>Unit Price</TableCell>
              <TableCell>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>{volume}</TableCell>
              <TableCell>{locale.liters}</TableCell>
              <TableCell>{prettifyProduct(redemptionItem?.productCode)}</TableCell>
              <TableCell align="right">{formatAmount(unitPrice)}</TableCell>
              <TableCell align="right">{formatAmount(unitAmount)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2}></TableCell>
              <TableCell>
                <Text>{locale.discount}</Text>
              </TableCell>
              <TableCell align="right">{`- ${formatAmount(discountPerUnit)}/L`}</TableCell>
              <TableCell align="right">{`- ${formatAmount(discountPerTotal)}`}</TableCell>
            </TableRow>
            <TableRow className={styles.removeBorderButton}>
              <TableCell colSpan={2} className={styles.vatSpace}></TableCell>
              <TableCell className={styles.vatSpace}>{locale.vatTableSales}</TableCell>
              <TableCell className={styles.vatSpace}></TableCell>
              <TableCell align="right" className={styles.vatSpace}>
                {formatAmount(vatableSales)}
              </TableCell>
            </TableRow>
            <TableRow className={styles.removeBorderButton}>
              <TableCell colSpan={2} className={styles.vatSpace}></TableCell>
              <TableCell className={styles.vatSpace}>{locale.vatExemptSales}</TableCell>
              <TableCell className={styles.vatSpace}></TableCell>
              <TableCell align="right" className={styles.vatSpace}>
                {formatAmount(0)}
              </TableCell>
            </TableRow>
            <TableRow className={styles.removeBorderButton}>
              <TableCell className={styles.vatSpace} colSpan={2}></TableCell>
              <TableCell className={styles.vatSpace}>{locale.vatZeroRatedSales}</TableCell>
              <TableCell className={styles.vatSpace}></TableCell>
              <TableCell align="right" className={styles.vatSpace}>
                {formatAmount(0)}
              </TableCell>
            </TableRow>
            <TableRow className={styles.removeBorderButton}>
              <TableCell className={styles.vatSpace} colSpan={2}></TableCell>
              <TableCell className={styles.vatSpace}>{locale.vatAmount}</TableCell>
              <TableCell className={styles.vatSpace}></TableCell>
              <TableCell align="right" className={styles.vatSpace}>
                {formatAmount(vatAmount)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2}></TableCell>
              <TableCell>
                <Text strong>{locale.totalAmountDue}</Text>
              </TableCell>
              <TableCell></TableCell>
              <TableCell align="right">
                <Text strong>{formatAmount(totalAmountDue)}</Text>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Modal>
  );
};

export default PayWithLOCQPayReceiptGuideModal;
